
import { MdsItem, ValidationResult } from '../types';

/**
 * NAMESPACE: ext_mds_validation
 * Fungsi-fungsi di bawah ini bersifat additive untuk memproses validasi hierarki 
 * tanpa menyentuh logic existing di bomProcessor.ts
 */

export const ext_validateHierarchy = (items: MdsItem[]): ValidationResult => {
  const errors: string[] = [];
  const itemMap = new Map<string, MdsItem>();

  // Indeks item untuk pencarian cepat
  items.forEach(item => {
    if (item.part_number_customer) {
      itemMap.set(item.part_number_customer, item);
    }
  });

  // 1. Validasi Root
  if (items.length > 0 && !items.some(i => i.level === 0)) {
    errors.push("Struktur Error: Tidak ditemukan Root Assembly (Level 0).");
  }

  items.forEach(item => {
    // 2. Validasi Relasi Parent-Child
    if (item.level > 0 && item.parent_part_number) {
      const parent = itemMap.get(item.parent_part_number);
      if (!parent) {
        errors.push(`Hierarchy Error: Item ${item.part_number_customer} mereferensikan Parent [${item.parent_part_number}] yang tidak terdaftar.`);
      } else if (item.level <= parent.level) {
        errors.push(`Sequence Error: Level item ${item.part_number_customer} (L${item.level}) harus lebih besar dari Parent ${parent.part_number_customer} (L${parent.level}).`);
      }
    }

    // 3. Deteksi Circular Reference
    let current: MdsItem | undefined = item;
    const visited = new Set<string>();
    while (current && current.parent_part_number) {
      if (visited.has(current.part_number_customer)) {
        errors.push(`Circular BOM: Terdeteksi loop pada item ${item.part_number_customer}.`);
        break;
      }
      visited.add(current.part_number_customer);
      current = itemMap.get(current.parent_part_number);
    }
  });

  return {
    isValid: errors.length === 0,
    errors
  };
};

export const ext_analyzeWeightDiscrepancy = (tree: MdsItem[]): string[] => {
  const discrepancies: string[] = [];

  const checkNode = (node: MdsItem) => {
    if (node.children && node.children.length > 0) {
      const childrenSum = node.children.reduce((acc, child) => acc + (child.berat_total || 0), 0);
      
      // Jika berat yang diinput manual ada, bandingkan dengan kalkulasi sistem
      if (node.berat_level > 0 && Math.abs(node.berat_level - (childrenSum / node.qty_total)) > (node.berat_level * 0.01)) {
        discrepancies.push(`Weight Conflict: Berat ${node.part_number_customer} (${node.berat_level}g) tidak sinkron dengan total komponen di bawahnya (${(childrenSum / node.qty_total).toFixed(3)}g).`);
      }
      
      node.children.forEach(checkNode);
    }
  };

  tree.forEach(checkNode);
  return discrepancies;
};
